//#region src/scroll-restoration-script/client.ts
function getScrollRestorationScriptForRouter(_router) {
	return null;
}
//#endregion
export { getScrollRestorationScriptForRouter };

//# sourceMappingURL=client.js.map